import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: black;
`

export const AddAlbumForm = styled.form<{ $isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  background-color: white;
  max-width: 500px;
  ${({ $isMobile }) =>
    $isMobile
      ? `
            width: calc(100% - 16px);
            padding: 8px;
            margin-top: 0px;,
            `
      : `
            width: calc(100% - 32px);
            padding: 16px;
            box-shadow: 0px 0px 24px rgba(0,0,0,0.1);
            margin-top: 100px;
            border-radius: 8px;
            `}
`
